import keyMirror from 'react-utils/keyMirror';
const TwoFactorAuthSMSErrors = keyMirror({
  SMS_NOT_SENT: null,
  NUMBER_ALREADY_REGISTERED: null,
  UNSUPPORTED_COUNTRY: null,
  NOT_VALID_NUMBER: null,
  NOT_ALLOWED: null
});
export default TwoFactorAuthSMSErrors;